import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _Promise from 'babel-runtime/core-js/promise';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

// import LanguageMenu from '../../layout/components/pt/language-menu.vue'
import Breadcrumb from './crumb.vue';
import { getToken } from '@/utils/auth';
import SaveButton from './save-button.vue';
import ActionDropdown from './action-dropdown.vue';
import TemplateState from './template-state.vue';
import { mapState } from 'vuex';
import CommonTemplateCrumb from './common-template-crumb.vue';
import ResetTemplate from '../components/reset-template.vue';
import CopyCreativeDropdown from './copy-creative-dropdown.vue';
import MoreOperateDropdown from './more-operate-dropdown.vue';
import PackageManager from '../components/package-manager.vue';
import DownloadBasic from './download-basic.vue';
import { v2Host } from '@/config/host';
import qs from 'qs';
import BindProjectBar from '@pt/components/bind-project/bind-project-bar';
import BindProjectTips from '@pt/components/bind-project/bind-project-tips';
import TaskCenter from '@pt/components/task-center/index.vue';
import LogoP from '@/views/layout/components/pt/logo-p.vue';
import CopyCreative from '@/views/creative/components/creative-info/edit-creative.vue';
import { createPSProject } from '@ps/api/project';
import { playsmartEntry } from '@pt/config';
import _ from 'lodash';

export default {
  components: {
    LogoP: LogoP,
    // LanguageMenu,
    CopyCreative: CopyCreative,
    Breadcrumb: Breadcrumb,
    SaveButton: SaveButton,
    ActionDropdown: ActionDropdown,
    TemplateState: TemplateState,
    CommonTemplateCrumb: CommonTemplateCrumb,
    ResetTemplate: ResetTemplate,
    CopyCreativeDropdown: CopyCreativeDropdown,
    MoreOperateDropdown: MoreOperateDropdown,
    PackageManager: PackageManager,
    DownloadBasic: DownloadBasic,
    BindProjectBar: BindProjectBar,
    BindProjectTips: BindProjectTips,
    TaskCenter: TaskCenter
  },

  data: function data() {
    return {};
  },


  watch: {
    jobUpdate: function jobUpdate(val) {
      console.log('jobUpdate change', val);
      if (val) {
        this.$refs.taskCenter.getTaskList();
      }
    }
  },

  computed: _extends({}, mapState({
    isReadonly: function isReadonly(state) {
      return state.creative.template.isReadonly;
    },
    isCommonTemplateCustom: function isCommonTemplateCustom(state) {
      return state.creative.template.isCommonTemplateCustom;
    },
    userInfo: function userInfo(state) {
      return state.user.info;
    },
    id: function id(state) {
      return state.creative.template.id;
    },
    bind_demand: function bind_demand(state) {
      return state.creative.template.bind_demand;
    },
    jobUpdate: function jobUpdate(state) {
      return state.pt.websocket.jobUpdate;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    is_allow_ps: function is_allow_ps(state) {
      return state.user.info.is_allow_ps;
    }
  }), {
    canCopyToPs: function canCopyToPs() {
      if (this.is_allow_ps === 1 && this.templateConfig.is_allow_ps === 1 && this.$route.name === 'common-template.custom') {
        return true;
      }
      return false;
    },
    token: function token() {
      return getToken();
    }
  }),

  mounted: function mounted() {},


  methods: {
    navigate: function navigate(path) {
      this.$router.push({
        path: path
      });
    },
    handleCopyPSTmpl: function handleCopyPSTmpl(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, code, errorMsg, _$get, id;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                params.source = 'gm';
                _context.next = 4;
                return createPSProject(params);

              case 4:
                res = _context.sent;
                code = _.get(res, 'code');

                if (!(code === 1)) {
                  _context.next = 12;
                  break;
                }

                errorMsg = _.get(res, 'msg');

                _this.$message.error(errorMsg);
                return _context.abrupt('return', _Promise.reject(_Object$assign({}, res, { message: errorMsg })));

              case 12:
                if (!(code === 0)) {
                  _context.next = 15;
                  break;
                }

                _$get = _.get(res, 'data'), id = _$get.id;
                // 根据 pt 格式拼接返回参数

                return _context.abrupt('return', {
                  data: {
                    data: {
                      project_id: id
                    }
                  }
                });

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 17]]);
      }))();
    },
    handleCopySuccess: function handleCopySuccess(_ref) {
      var _ref$data = _ref.data,
          data = _ref$data === undefined ? {} : _ref$data;
      var id = data.id;

      window.location.href = playsmartEntry + '#/workbench?id=' + id;
    },
    handleDownloadBasic: function handleDownloadBasic(quality) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var path, data, downloadUrl;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$refs['saveButton'].saveTemplateInfo();

              case 2:
                path = _this2.isCommonTemplateCustom ? '/gmaker/project/export-basic' : '/dmaker/custom/export-basic';
                data = {
                  id: String(_this2.id),
                  quality: quality
                };
                downloadUrl = '' + v2Host + path + '?' + qs.stringify(data);

                window.open(downloadUrl, '_blank');

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    logout: function logout() {
      this.$store.dispatch('LogOut');
    },
    handleUpdateBindDemand: function handleUpdateBindDemand(data) {
      this.$store.commit('creative/template/updateBindDemand', data);
    },
    handleTaskCenterShow: function handleTaskCenterShow() {
      this.$store.commit('pt/websocket/updateJobUpdate', false);
    }
  }
};